module.exports = __webpack_public_path__ + "img/in.0d2a426b.svg";